import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

/**
 * True on phones, folded foldables and portrait tablets - the widths where a
 * multi-column table cannot be read without horizontal scrolling, and list
 * views should render stacked cards instead.
 */
const useCompactLayout = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

export default useCompactLayout;
